module.exports = __webpack_public_path__ + "media/outbou.55eb7bae.mp4";